import { declareRoute } from "utilities/routes/route.utility";

export const apiDocsRoute = declareRoute("/apidocs");

/** Scratchpad for exercising ADK agents through APIX. See src/agentTester/AgentTester.tsx. */
export const agentTesterRoute = declareRoute("/agenttester");
